import React from "react";
import PropTypes from "prop-types";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

export const FILTER_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "last_7_days", label: "Last 7 Days" },
  { value: "last_30_days", label: "Last 30 Days" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "this_quarter", label: "This Quarter" },
  { value: "this_year", label: "This Year" },
  { value: "custom", label: "Custom Range" },
];

// Shared date-range control rendered once (see src/app/analytics/index.js) and passed down
// to whichever tab is active — matches the modern @mui/x-date-pickers + AdapterDayjs pattern
// already used in src/app/auspostmonthlyorder/.
const AnalyticsFilterBar = ({ filter, startDate, endDate, onChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        alignItems: "center",
        flexWrap: "wrap",
        backgroundColor: "#fff",
        padding: "1rem",
        marginBottom: "1rem",
        borderRadius: "4px",
      }}
    >
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="analytics-filter-label">Date Range</InputLabel>
        <Select
          labelId="analytics-filter-label"
          label="Date Range"
          value={filter}
          onChange={(event) => onChange({ filter: event.target.value, startDate, endDate })}
        >
          {FILTER_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {filter === "custom" && (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="From"
            value={startDate ? dayjs(startDate) : null}
            onChange={(newValue) =>
              onChange({
                filter,
                startDate: newValue ? newValue.format("YYYY-MM-DD") : "",
                endDate,
              })
            }
            slotProps={{ textField: { size: "small" } }}
          />
          <DatePicker
            label="To"
            value={endDate ? dayjs(endDate) : null}
            onChange={(newValue) =>
              onChange({
                filter,
                startDate,
                endDate: newValue ? newValue.format("YYYY-MM-DD") : "",
              })
            }
            slotProps={{ textField: { size: "small" } }}
          />
        </LocalizationProvider>
      )}
    </Box>
  );
};

AnalyticsFilterBar.propTypes = {
  filter: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default AnalyticsFilterBar;
